import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';


import { api } from '../api';

const SendNotification: React.FC = () => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [link, setLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!title.trim() || !message.trim()) {
      setError('Title and Message are required.');
      return;
    }

    setLoading(true);

    try {
      await api.post(`/notifications/send-notification`, {
        title,
        link,
        message,
      });
      setSuccess(true);
      setTitle('');
      setMessage('');
      setLink('')
      // Optionally navigate back to notifications list after success
      // navigate('/notifications');
    } catch (err) {
      setError('Failed to send notification. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxWidth={500} mx="auto" mt={5} p={3} boxShadow={2} borderRadius={2}>
      <Typography variant="h5" mb={3}>
        Send Notification
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Notification sent successfully!
        </Alert>
      )}

      <form onSubmit={handleSubmit} >
        <TextField
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          fullWidth
          required
          margin="normal"
          disabled={loading}
        />

        <TextField
          label="Link"
          value={link}
          type="url"
          onChange={(e) => setLink(e.target.value)}
          fullWidth
          required
          margin="normal"
          disabled={loading}
        />

        <TextField
          label="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth
          required
          margin="normal"
          multiline
          rows={4}
          disabled={loading}
        />

        <Box mt={3} display="flex" justifyContent="space-between" alignItems="center">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
          >
            Send
          </Button>

          {loading && <CircularProgress size={24} />}
        </Box>
      </form>
    </Box>
  );
};

export default SendNotification;
